import { render, staticRenderFns } from "./modifypass.vue?vue&type=template&id=c5d2960a&scoped=true&"
import script from "./modifypass.vue?vue&type=script&lang=js&"
export * from "./modifypass.vue?vue&type=script&lang=js&"
import style0 from "./modifypass.vue?vue&type=style&index=0&id=c5d2960a&lang=less&scoped=true&"
import style1 from "./modifypass.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d2960a",
  null
  
)

export default component.exports